<template>
    <div class="custom-tooltip" :style="containerStyle">
        <i class="fas fa-info-circle"></i>
        <span class="custom-tooltiptext" :class="position">
            <slot></slot>
        </span>
    </div>
</template>

<script>
export default {
    name: "Tooltip",
    props: {
        position: {
            type: String,
            default: "top", // default position
            validator: value => ["top", "right", "bottom", "left"].includes(value)
        },
        width: {
            type: String,
            default: "400px"
        }
    },
    computed: {
        containerStyle() {
            return {
                display: "inline-block",
                position: "relative"
            };
        }
    }
};
</script>

<style>
.custom-tooltip {
    position: relative;
    display: flex;
}

.custom-tooltip .custom-tooltiptext {
    visibility: hidden;
    background-color: white;
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 6px;
    position: absolute;
    z-index: 10000;
    min-width: 250px;
    width: 400px;
    text-align: left;
    font-weight: normal;
}

/* Show tooltip on hover */
.custom-tooltip:hover .custom-tooltiptext {
    visibility: visible;
}

/* Position variations */
.custom-tooltiptext.top {
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 8px;
}

.custom-tooltiptext.right {
    top: 50%;
    transform: translateY(-50%);
    margin-left: 8px;
}

.custom-tooltiptext.bottom {
    top: 100%;
    /* left: 50%; */
    /* transform: translateX(-50%); */
    /* margin-top: 8px; */
}

.custom-tooltiptext.left {
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
    margin-right: 8px;
}
</style>
